<template>
    <kgr-profile-part v-if="memberShortProfile.paymentInformation !== null">
        <template #heading>
            <div class="kgr-postfix kgr-postfix--center kgr-postfix--gutters kgr-row">
                <div class="kgr-postfix__fixed">
                    <h2
                        v-t="'Zahlungsinformationen'"
                        class="kgr-headline kgr-headline--h3"
                    ></h2>
                </div>
            </div>
        </template>

        <template #content>
            <table class="kgr-table">
                <tbody>
                    <tr
                        class="kgr-table__row kgr-table__row--top"
                    >
                        <td
                            v-t="'Offener Gesamtbetrag:'"
                            class="kgr-table__cell"
                        ></td>
                        <td class="kgr-table__cell">
                            <a
                                class="kgr-link"
                                :href="memberShortProfile.paymentInformation.linkToInvoices"
                            >
                                {{ formatOpenAmount }}
                            </a>
                        </td>
                    </tr>
                    <tr
                        class="kgr-table__row kgr-table__row--top"
                    >
                        <td
                            v-t="'Standard-Zahlart:'"
                            class="kgr-table__cell"
                        ></td>
                        <td class="kgr-table__cell">
                            {{ translatedPaymentMethod }}
                        </td>
                    </tr>
                    <tr
                        v-if="memberShortProfile.paymentInformation.iban"
                        class="kgr-table__row kgr-table__row--top"
                    >
                        <td
                            v-t="'memberShortProfile.paymentInformation.iban'"
                            class="kgr-table__cell"
                        ></td>
                        <td class="kgr-table__cell">
                            {{ memberShortProfile.paymentInformation.iban }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </template>
    </kgr-profile-part>
</template>

<script>
import MemberShortProfile from '../../../js/dto/MemberShortProfile';
import Money from '../../../js/dto/Money';
import ProfilePart from '../../short-profile/ProfilePart.vue';

export default {
    name: 'KgrMemberPartPaymentInformation',
    components: {
        'kgr-profile-part': ProfilePart,
    },
    props: {
        memberShortProfile: {
            type: MemberShortProfile,
            required: true,
        },
    },
    computed: {
        formatOpenAmount() {
            const openAmount = Money.fromData(this.memberShortProfile.paymentInformation.openAmount);
            return openAmount.toLocalizedString() + ' ' + openAmount.currency;
        },
        translatedPaymentMethod() {
            return this.$t('club.paymentMethod.' + this.memberShortProfile.paymentInformation.paymentMethod);
        }
    },
}
</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
